"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if a value does not match ("!==") the comparison.
 *
 * @export
 * @class IsNotEqualValidator
 * @implements {PropertyValidator<T>}
 * @template T
 */
class IsNotEqualValidator {
    constructor(comparison) {
        this.comparison = comparison;
    }
    isValid(input) {
        return this.comparison !== input;
    }
}
exports.IsNotEqualValidator = IsNotEqualValidator;
//# sourceMappingURL=IsNotEqualValidator.js.map